const manufacturers = {
    namespaced: true,
    state: {
        vehicleManufacturers: [],
        canopyManufacturers: []
    },
    mutations: {
        setVehicleManufacturers(state, manufacturers) {
            state.vehicleManufacturers = manufacturers;
        },
        setCanopyManufacturers(state, manufacturers) {
            state.canopyManufacturers = manufacturers;
        }
    },
    actions: {
        async getVehicleManufacturers({ commit }) {
            let response = await axios.get("api/vehicle/makes");
            commit("setVehicleManufacturers", response.data.data);
        },
        async getCanopyManufacturers({ commit }) {
            let response = await axios.get("api/canopy/manufacturers");
            commit("setCanopyManufacturers", response.data.data);
        }
    },
    getters: {}
};

export default manufacturers;
